import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { v4 as uuid } from "uuid";

import { createNewSymptom } from "../../data/omniDataModel.js";
import * as PatientSessionActions from "../../state/redux/patientSession.js";
import { deepCopyObject } from "../../utils/helpers.js";
import PatientSymptomsDialog from "../dialogs/patientSymptomsDialog.js";
import SymptomDialog from "../dialogs/symptomDialog.js";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import SymptomListItem from "../ui/symptomListItem.js";
import Widget from "../ui/widget.js";
import WidgetList from "../ui/widgetList.js";
import WidgetSkeleton from "../ui/widgetSkeleton.js";
import WidgetTitle from "../ui/widgetTitle.js";

const PatientProxySymptoms = props => {
  const { patientODM, title = "Health", allowAdd = true } = props;

  const [showInputDialog, setShowInputDialog] = useState(null);
  const [selectedSymptomODM, setSelectedSymptomODM] = useState(null);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (patientODM != null) {
      setTitleText(
        `${patientODM.omniData.patientData.symptomODMs.length} Symptom${
          patientODM.omniData.patientData.symptomODMs.length === 1 ? "" : "s"
        }`,
      );
    } else setTitleText("");
  }, [patientODM]);

  return (
    <Widget>
      <WidgetTitle title={title} text={titleText} loading={patientODM == null}>
        {allowAdd && (
          <OmniResponsiveButton
            tooltipTitle="Add New Symptoms"
            buttonText="New"
            icon={<AddIcon />}
            onClick={() => {
              let newSymptom = createNewSymptom();
              setSelectedSymptomODM(newSymptom);
            }}
          />
        )}
        {
          <OmniResponsiveButton
            tooltipTitle="Update Symptoms"
            buttonText="Update"
            icon={<EditIcon />}
            onClick={() => {
              setShowInputDialog(true);
            }}
          />
        }
      </WidgetTitle>

      {patientODM == null && <WidgetSkeleton />}
      {patientODM != null && (
        <WidgetList>
          {patientODM != null &&
            patientODM.omniData.patientData.symptomODMs.map((symptomODM, index) => {
              return (
                <SymptomListItem
                  key={index}
                  index={index}
                  symptom={symptomODM}
                  onClickHandler={setSelectedSymptomODM}
                  //todo this will need to check the symptom for the apprope behavior
                />
              );
            })}
        </WidgetList>
      )}

      {showInputDialog != null && (
        <PatientSymptomsDialog
          open={showInputDialog != null}
          symptomODMs={patientODM.omniData.patientData.symptomODMs}
          onAccept={updatedSymptoms => {
            let newPatientODM = deepCopyObject(patientODM); //might not need?
            newPatientODM.omniData.patientData.symptomODMs = updatedSymptoms;
            props.updatePatientRequest(newPatientODM);
            setShowInputDialog(null);
          }}
          onClose={() => {
            setShowInputDialog(null);
          }}
        />
      )}

      {selectedSymptomODM && (
        <SymptomDialog
          open={selectedSymptomODM != null}
          symptomODM={selectedSymptomODM}
          tabId={selectedSymptomODM.timeSeries.length > 1 ? 1 : 0}
          onAccept={theSymptom => {
            if (theSymptom._id == null) {
              theSymptom._id = uuid();
              let updatedODM = deepCopyObject(patientODM);
              updatedODM.omniData.patientData.symptomODMs.push(theSymptom);
              props.updatePatientRequest(updatedODM);
            } else {
              let updatedODM = deepCopyObject(patientODM);
              const newSymptoms = updatedODM.omniData.patientData.symptomODMs.filter(
                obj => obj._id !== theSymptom._id,
              );
              newSymptoms.push(theSymptom);
              updatedODM.omniData.patientData.symptomODMs = newSymptoms;
              props.updatePatientRequest(updatedODM);
            }
            setSelectedSymptomODM(null);
          }}
          onClose={() => {
            setSelectedSymptomODM(null);
          }}
          onDelete={theSymptom => {
            if (theSymptom._id != null) {
              let updatedODM = deepCopyObject(patientODM);
              const newSymptoms = updatedODM.omniData.patientData.symptomODMs.filter(
                obj => obj._id !== theSymptom._id, //no _
              );
              updatedODM.omniData.patientData.symptomODMs = newSymptoms;
              props.updatePatientRequest(updatedODM);
            }
            setSelectedSymptomODM(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  patientODM: state.userSession.proxyPatientODM,
});

const mapDispatchToProps = {
  updatePatientRequest: PatientSessionActions.updatePatientRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientProxySymptoms);
